export default __webpack_public_path__ + "static/media/samina.c23335b1.png";